export const rDpdWidget = {
    apiKey: null,
    async init(apiKey, options = {}) {
        try {
            if (!apiKey) {
                console.error("apiKey is not defined");

                return;
            }

            this.apiKey = apiKey;

            const dpdWidget = new DpdPudo.Widget({
                apiKey,
                ...options,
            });

            setTimeout(() => {
                for (const shippingInput of document.querySelectorAll(
                    "input[r-dpd-parcelshop-input]"
                )) {
                    shippingInput.addEventListener("change", async (event) => {
                        if (
                            event.target.querySelector("[r-dpd-parcelshop-trigger]") &&
                            !document
                                .querySelector("[r-dpd-parcelshop-empty]")
                                .classList.contains("hidden")
                        ) {
                            try {
                                const pudo = await dpdWidget.open();
                                this.processSelectedBranch(pudo);
                            } catch (error) {
                                console.error("Failed to open dpdWidget:", error);
                            }
                        }
                    });
                }
            }, 100);

            for (const trigger of document.querySelectorAll("[r-dpd-parcelshop-trigger]")) {
                trigger.addEventListener("click", async (event) => {
                    try {
                        const pudo = await dpdWidget.open();
                        this.processSelectedBranch(pudo);
                    } catch (error) {
                        console.error("Failed to open dpdWidget:", error);
                    }
                });
            }

            const pickupInput = document.querySelector("input[r-dpd-parcelshop-input]");

            pickupInput.closest(".js-module-label").addEventListener("click", async (event) => {
                try {
                    const pudo = await dpdWidget.open();
                    this.processSelectedBranch(pudo);
                } catch (error) {
                    console.error("Failed to open dpdWidget:", error);
                }
            });
        } catch (error) {
            console.log("ERROR", error);
        }
    },
    successCallback(data) {
        document.querySelector("input[r-dpd-parcelshop-input]").value = data.id;
        document.querySelector('input[name="shipping_name"][r-dpd-additional-input]').value =
            data.name;
        document.querySelector('input[name="shipping_address"][r-dpd-additional-input]').value =
            data.street;
        document.querySelector('input[name="shipping_post_code"][r-dpd-additional-input]').value =
            data.zip;
        document.querySelector('input[name="shipping_city"][r-dpd-additional-input]').value =
            data.city;

        document.querySelector("[r-dpd-parcelshop-selected]").classList.remove("hidden");
        document.querySelector("[r-dpd-parcelshop-selected-branch]").innerText = data.name;
        document.querySelector("[r-dpd-parcelshop-selected-address]").innerText = data.addressText;
        document.querySelector("[r-dpd-parcelshop-empty]").classList.add("hidden");
        document.getElementById("error-branch").style.display = "none";

        window.updateObjednavky();
    },
    processSelectedBranch(data) {
        $.post("/create-dpd-parcelshop-branch", data).then((response) => {
            const responseData = response.data;
            console.log("responseData", responseData);

            if (!response.status) {
                return false;
            }

            data.id = responseData.id;

            this.successCallback(data);
        });
    },
};
